import React from 'react'
import { Link } from 'react-router-dom'
import black from '../images/black.png'
import white from '../images/whi.png'
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { useState,useEffect } from 'react'

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [open,setOpen]=useState(true)
  console.log(open)

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      if (scrollTop > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className=''>
       <div className={`${open ? "invisible " :''} w-full h-3/4 md:hidden top-0 fixed bg-black opacity-85 `}>
       <div className='flex justify-center items-center p-4 mt-20 gap-10'> 
        <ul>
         <Link to={'/'}> <li className='text-white text-lg font-bold p-4 px-16 mb-4 text-center outline'>Home</li></Link>
         <Link to={'/advertise'}> <li className='text-white text-lg font-bold p-4 px-16 mb-4 text-center outline'>Advertise</li></Link>
         <Link to={'/about'}><li className='text-white text-lg font-bold p-4 px-16 mb-4 text-center outline'>About</li></Link>
         <Link to={'/contact'}><li className='text-white text-lg font-bold p-4 px-16 mb-4 text-center outline'>Contact</li></Link>
          
        </ul>
       </div>
         
        </div>
      <div className={` fixed bg-gray-700 text-white top-0 left-0 w-full  flex items-center justify-between p-3 border-b-2   h-16 pl-2 pr-8`}>
        <div className=" mt-2">
          <Link to={'/'}> <img src={white} className=" w-28 h-28 text-white" alt="Fre Piyo" /></Link>
        </div>
        <div className="">
          <ul className='flex items-center justify-between gap-5'>
            <li className='text-lg px-2 hover:outline-dashed active:underline md:block max-sm:hidden '><Link to={'/'}>Home</Link></li>
            <li className='text-lg px-2 hover:outline-dashed md:block max-sm:hidden'><Link to={'/advertise'}>Advertise</Link></li>
            
            
          </ul>
        </div>
        <div onClick={()=>setOpen(!open)} className={`md:hidden max-sm:block cursor-pointer `}>
          {open ?<MenuIcon/>:<CloseIcon/>}
        </div>
       
        <div className="px-2 text-lg py-1 hover:outline-dashed md:block max-sm:hidden">
          <Link to={'/contact'}>Get in Touch</Link>
        </div>
      </div>
    </div>
  )
}

export default Header